import { useCallback, useRef, useState } from 'react'

import pdfMake from 'pdfmake/build/pdfmake'
import vfsFonts from 'pdfmake/build/vfs_fonts'
import { TDocumentDefinitions } from 'pdfmake/interfaces'
import {
    Board,
    DimensionExportToReport,
    OverviewFullPreviewReportStructureExport,
    QuestionsExportToReport,
    SummaryExportToReport,
} from '../structure/structureOverviewPreviewReport'
import { configPdfMakeFullReport } from '../../../utils/pdfMake'
import linePng from '../../../components/report/line.png'
import lineGrey from '../../../components/report/linegrey.png'
import useStore from '../../../stores/useStore'
import jwt from 'jsonwebtoken'
import { getSessionStorage, keyNameSessionStorage } from '../../../utils/sessionStorage'
import probe from 'probe-image-size'

const { vfs } = vfsFonts.pdfMake
pdfMake.vfs = vfs
pdfMake.fonts = {
    THSarabun: {
        normal: 'THSarabunNew.ttf',
        bold: 'THSarabunNew-Bold.ttf',
        italics: 'THSarabunNew-Italic.ttf',
        bolditalics: 'THSarabunNew-BoldItalic.ttf',
    },
    Roboto: {
        normal: 'Roboto-Regular.ttf',
        bold: 'Roboto-Medium.ttf',
        italics: 'Roboto-Italic.ttf',
        bolditalics: 'Roboto-MediumItalic.ttf',
    },
    Webdings: {
        normal: 'webdings.ttf',
        bold: 'webdings.ttf',
        italics: 'webdings.ttf',
        bolditalics: 'webdings.ttf',
    },
    Webdings2: {
        normal: 'wingdng2.TTF',
        bold: 'wingdng2.TTF',
        italics: 'wingdng2.TTF',
        bolditalics: 'wingdng2.TTF',
    },
}

type imgSizeType = {
    width: number
    height: number
    length: number
    type: string
    mime: string
    wUnits: string
    hUnits: string
    url: string
}
// type ReturnTypeHookUseExportReportOverviewPDF = ReturnType<typeof useExportReportOverviewPDF>
type UseExportReportOverviewPDF = { fromUrl: boolean }
const useExportFullReportOverviewPDF = (props: UseExportReportOverviewPDF) => {
    const { fromUrl } = props
    let isAdmin: boolean
    if (fromUrl) {
        isAdmin = true
    } else {
        const accessToken = getSessionStorage(keyNameSessionStorage.accessToken) || ''
        const jwtDecoded = jwt.decode(accessToken, { complete: true }) as {
            payload?: {
                key?: Number
                exp?: number
                roles?: string[]
            }
        }
        isAdmin = (jwtDecoded.payload?.roles?.[0] as string) !== 'USER'
    }

    const { loadingStore } = useStore()
    const [isLoadingDownloadFullReportPdf] = useState(false)

    const [isLoadingOpenFullReportPdf, setLoadingOpenFullReportPdf] = useState(false)
    const imgCoverRef = useRef<string>('')
    const imgSizeRef = useRef<imgSizeType>({
        width: 0,
        height: 0,
        length: 0,
        type: '',
        mime: '',
        wUnits: '',
        hUnits: '',
        url: '',
    })

    const getDocDefinitionPdf = useCallback(
        async ({ data = [] }: { data: OverviewFullPreviewReportStructureExport[] }) => {
            try {
               
                imgCoverRef.current = data[0].communityImg
                imgSizeRef.current = await probe(data[0].communityImg)
              
            } catch (error) {
                imgCoverRef.current = `${process.env.REACT_APP_REPORT_DEFAULT_COVER}`
                imgSizeRef.current = await probe(`${process.env.REACT_APP_REPORT_DEFAULT_COVER}`)
            }

            const docDefinition = {
                ...configPdfMakeFullReport,
                pageSize: 'A4',
                pageMargins: [50, 60, 50, 60],
                content: [
                    ...data.map(({ dimensions, ...item }) => {
                        return [
                            ...generateCover(
                                item.communityName,
                                item.questionnaireName,
                                item.date,
                                item.boards,

                                imgSizeRef.current,
                            ),
                            ...generateQuestionnaireChart({
                                name: item.questionnaireName,
                                image: item.questionnaireRef as string,
                                data: dimensions,
                            }),
                            ...generateDimensionChart({ data: dimensions, adminDone: item.admin, userDone: item.user }),
                        ]
                    }),
                ],
                images: {
                    mySuperImage: 'data:image/jpeg;base64,...content...',
                    communityImg: imgCoverRef.current,
                },
            } as TDocumentDefinitions
            return docDefinition
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [],
    )

    const generateCover = useCallback(
        (
            communityName: string,
            questionnaireName: string,
            date: string,
            boards: Board[],
            imgSize: probe.ProbeResult,
        ) => {
            let imgwidth = imgSize.width,
                imgheight = imgSize.height

            if (imgheight > 300) {
                imgwidth = (imgwidth / imgheight) * 350
                imgheight = 300
                if (imgwidth > 490) {
                    imgheight = (imgheight / imgwidth) * 575
                    imgwidth = 490
                }
            } else if (imgwidth > 490) {
                imgheight = (imgheight / imgwidth) * 575
                imgwidth = 490
            }
            console.log('w h', imgwidth, imgheight)

            return [
                {
                    stack: [
                        {
                            image: 'communityImg',
                            width: imgwidth,
                            height: imgheight,
                            alignment: 'left',
                        },
                    ],
                },
                {
                    text: ' ',
                },
                {
                    text: ' ',
                },
                {
                    text: `${communityName}`,
                    fontSize: 36,
                    bold: true,
                    color: '#009687',
                },
                {
                    text: ' ',
                },
                {
                    stack: [
                        {
                            image: linePng,
                            width: 100,
                            height: 1,
                        },
                    ],
                },
                {
                    text: ' ',
                },
                {
                    text: `การประเมิน : ${questionnaireName}`,
                    fontSize: 28,
                    bold: true,
                },
                {
                    text: ' ',
                },
                {
                    text: `แหล่งที่มาของข้อมูล :`,
                    fontSize: 14,
                    bold: true,
                },
                {
                    text: `ระบบ CBT Thailand`,
                    margin: [15, 0, 0, 0],
                    fontSize: 14,
                },
                {
                    text: `พัฒนาโดย :`,
                    fontSize: 14,
                    bold: true,
                },
                {
                    text: `องค์การบริหารการพัฒนาพื้นที่พิเศษเพื่อการท่องเที่ยวอย่างยั่งยืน (องค์การมหาชน)`,
                    margin: [15, 0, 0, 0],
                    fontSize: 14,
                },
                {
                    text: `ในฐานะเลขานุการคณะอนุกรรมการการท่องเที่ยวโดยชุมชนภายใต้คณะกรรมการนโยบายการท่องเที่ยวแห่งชาติ`,
                    margin: [15, 0, 0, 0],
                    fontSize: 14,
                },
                {
                    text: ' ',
                },
                {
                    text: `${date}`,
                    fontSize: 28,
                    bold: true,
                    color: '#A8A8A8',
                },
                {
                    text: '',
                    pageBreak: 'after',
                },
                {
                    text: 'รายชื่อคณะกรรมการ',
                    bold: true,
                    fontSize: 28,
                    color: '#009687',
                },
                {
                    text: ' ',
                },
                {
                    stack: [
                        {
                            image: linePng,
                            width: 100,
                            height: 1,
                        },
                    ],
                },
                {
                    text: ' ',
                },
                generateBoard(boards),
                {
                    text: '',
                    pageBreak: 'after',
                },
            ]
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [],
    )

    const generateBoard = useCallback(
        (boards: Board[]) => {
            return {
                style: 'tableExample',
                table: {
                    widths: ['6%', '47%', '47%'],
                    body: [
                        [
                            {
                                text: 'ลำดับ',
                                style: 'tableHeader',
                                fillColor: '#EEF8F2',
                                fontSize: 16,
                                margin: [0, 0, 0, 0],
                                borderColor: ['#e9e7e8', '#e9e7e8', '#e9e7e8', '#e9e7e8'],
                            },
                            {
                                text: 'ชื่อ-นามสกุล',
                                style: 'tableHeader',
                                fillColor: '#EEF8F2',
                                fontSize: 16,
                                margin: [0, 0, 0, 0],
                                borderColor: ['#e9e7e8', '#e9e7e8', '#e9e7e8', '#e9e7e8'],
                            },
                            {
                                text: 'สังกัดหน่วยงาน',
                                style: 'tableHeader',
                                fillColor: '#EEF8F2',
                                fontSize: 16,
                                margin: [0, 0, 0, 0],
                                borderColor: ['#e9e7e8', '#e9e7e8', '#e9e7e8', '#e9e7e8'],
                            },
                        ],
                        ...(boards.length === 0
                            ? [
                                  [
                                      {
                                          text: 'ไม่มีข้อมูล',
                                          alignment: 'center',
                                          colSpan: 3,
                                          borderColor: ['#e9e7e8', '#e9e7e8', '#e9e7e8', '#e9e7e8'],
                                      },
                                      {},
                                      {},
                                  ],
                              ]
                            : boards.map((board, index: number) => {
                                  return [
                                      {
                                          text: index + 1,
                                          // text: '',
                                          alignment: 'left',
                                          style: 'text',
                                          fontSize: 16,
                                          margin: [0, 0, 0, 0],
                                          borderColor: ['#e9e7e8', '#e9e7e8', '#e9e7e8', '#e9e7e8'],
                                      },
                                      {
                                          text: `${board.name}`,
                                          // text: '',
                                          alignment: 'left',
                                          style: 'text',
                                          fontSize: 16,
                                          margin: [0, 0, 0, 0],
                                          borderColor: ['#e9e7e8', '#e9e7e8', '#e9e7e8', '#e9e7e8'],
                                      },
                                      {
                                          text: `${board.isnName}`,
                                          // text: '',
                                          alignment: 'left',
                                          style: 'text',
                                          fontSize: 16,
                                          margin: [0, 0, 0, 0],
                                          borderColor: ['#e9e7e8', '#e9e7e8', '#e9e7e8', '#e9e7e8'],
                                      },
                                  ]
                              })),
                    ],
                },
            }
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [],
    )

    const generateTableReport = useCallback(
        ({
            data = [],
            titleCell,
            prefixLabel,
        }: {
            data: SummaryExportToReport[]
            titleCell: string
            prefixLabel: string
        }) => {
            const isScoreAdminUndefined = data.every((dimension) => typeof dimension.scoreAdmin === 'undefined')
            const isScoreUserUndefined = data.every((dimension) => typeof dimension.scoreUser === 'undefined')

            const isScoreAdminNull = data.every((item) => item.scoreAdmin === null)
            const isScoreUserNull = data.every((item) => item.scoreUser === null)

            let totalScoreFull = 0
            let isNumberScoreFull = true
            const arrayTotalScoreFull = data.map((item) => item.scoreFull).filter((item) => typeof item === 'number')
            if (arrayTotalScoreFull.length > 0) {
                totalScoreFull = arrayTotalScoreFull.reduce((acc, crr) => {
                    return (acc as number) + (crr as number)
                })
            } else {
                isNumberScoreFull = false
            }

            let totalScoreUser: number | null | undefined = 0
            let totalScoreAdmin: number | null | undefined = 0

            const arrayScoreUser = data.map((item) => item.scoreUser).filter((item) => typeof item === 'number')
            if (arrayScoreUser.length > 0) {
                totalScoreUser = arrayScoreUser.reduce((acc, crr) => {
                    return (acc as number) + (crr as number)
                })
            }

            const arrayScoreAdmin = data.map((item) => item.scoreAdmin).filter((item) => typeof item === 'number')
            if (arrayScoreAdmin.length > 0) {
                totalScoreAdmin = arrayScoreAdmin.reduce((acc, crr) => {
                    return (acc as number) + (crr as number)
                })
            }

            let percentScoreUser
            let percentScoreAdmin

            if (typeof totalScoreUser === 'number') {
                percentScoreUser = (totalScoreUser * 100) / totalScoreFull
            }

            if (typeof totalScoreAdmin === 'number') {
                percentScoreAdmin = (totalScoreAdmin * 100) / totalScoreFull
            }

            return {
                style: 'tableExample',
                table: {
                    // widths: ['*', 70, 100, 100, 100, 100],
                    widths: ['34%', '10%', '12%', '16%', '12%', '16%'],
                    // widths: ['auto', 'auto', 'auto', 'auto', 'auto', 'auto'],
                    headerRows: 2,
                    dontBreakRows: true,
                    keepWithHeaderRows: 2,
                    body: [
                        [
                            {
                                text: titleCell,
                                style: 'tableHeader',
                                alignment: 'center',
                                rowSpan: 2,
                                fillColor: '#d9d9d9',
                                fontSize: 14,
                                borderColor: ['#e9e7e8', '#e9e7e8', '#e9e7e8', '#e9e7e8'],
                            },
                            {
                                text: 'คะแนนเต็ม',
                                style: 'tableHeader',
                                alignment: 'center',
                                rowSpan: 2,
                                fillColor: '#d9d9d9',
                                fontSize: 14,
                                borderColor: ['#e9e7e8', '#e9e7e8', '#e9e7e8', '#e9e7e8'],
                            },
                            {
                                text: 'คะแนนโดยชุมชน',
                                style: 'tableHeader',
                                alignment: 'center',
                                colSpan: 2,
                                fillColor: '#fced98',
                                fontSize: 14,
                                borderColor: ['#e9e7e8', '#e9e7e8', '#e9e7e8', '#e9e7e8'],
                            },
                            {},
                            {
                                text: 'คะแนนเจ้าหน้าที่',
                                style: 'tableHeader',
                                alignment: 'center',
                                colSpan: 2,
                                fillColor: '#d4e8dc',
                                fontSize: 14,
                                borderColor: ['#e9e7e8', '#e9e7e8', '#e9e7e8', '#e9e7e8'],
                            },
                            {},
                        ],
                        [
                            {},
                            {},
                            {
                                text: 'คะแนนที่ได้',
                                style: 'tableHeader',
                                alignment: 'center',
                                fillColor: '#fced98',
                                fontSize: 14,
                                borderColor: ['#e9e7e8', '#e9e7e8', '#e9e7e8', '#e9e7e8'],
                            },
                            {
                                text: 'ระดับคะแนน',
                                style: 'tableHeader',
                                alignment: 'center',
                                fillColor: '#fced98',
                                fontSize: 14,
                                borderColor: ['#e9e7e8', '#e9e7e8', '#e9e7e8', '#e9e7e8'],
                            },
                            {
                                text: 'คะแนนที่ได้',
                                style: 'tableHeader',
                                alignment: 'center',
                                fillColor: '#d4e8dc',
                                fontSize: 14,
                                borderColor: ['#e9e7e8', '#e9e7e8', '#e9e7e8', '#e9e7e8'],
                            },
                            {
                                text: 'ระดับคะแนน',
                                style: 'tableHeader',
                                alignment: 'center',
                                fillColor: '#d4e8dc',
                                fontSize: 14,
                                borderColor: ['#e9e7e8', '#e9e7e8', '#e9e7e8', '#e9e7e8'],
                            },
                        ],
                        ...data.map((dimension, index: number) => {
                            return [
                                {
                                    stack: [
                                        {
                                            text: `${prefixLabel}${index + 1} ${dimension.name}`,
                                            alignment: 'left',
                                            style: 'text',
                                            fontSize: 14,
                                            margin: [0, 0, 0, 0],
                                            noWrap: false,
                                        },
                                    ],
                                    borderColor: ['#e9e7e8', '#e9e7e8', '#e9e7e8', '#e9e7e8'],
                                },
                                {
                                    text: dimension.scoreFull,
                                    alignment: 'center',
                                    style: 'text',
                                    fontSize: 14,
                                    margin: [0, 0, 0, 0],
                                    borderColor: ['#e9e7e8', '#e9e7e8', '#e9e7e8', '#e9e7e8'],
                                },
                                {
                                    text:
                                        typeof dimension.scoreUser === 'number' ? dimension.scoreUser.toFixed(2) : '-',
                                    alignment: 'center',
                                    fillColor: '#fffce9',
                                    style: 'text',
                                    fontSize: 14,
                                    margin: [0, 0, 0, 0],
                                    borderColor: ['#e9e7e8', '#e9e7e8', '#e9e7e8', '#e9e7e8'],
                                },
                                {
                                    text: dimension.descriptionUser ?? '-',
                                    alignment: 'center',
                                    fillColor: '#fffce9',
                                    style: 'text',
                                    fontSize: 14,
                                    margin: [0, 0, 0, 0],
                                    borderColor: ['#e9e7e8', '#e9e7e8', '#e9e7e8', '#e9e7e8'],
                                },
                                {
                                    text:
                                        typeof dimension.scoreAdmin === 'number'
                                            ? dimension.scoreAdmin.toFixed(2)
                                            : '-',
                                    alignment: 'center',
                                    fillColor: '#f6fbf7',
                                    style: 'text',
                                    fontSize: 14,
                                    margin: [0, 0, 0, 0],
                                    borderColor: ['#e9e7e8', '#e9e7e8', '#e9e7e8', '#e9e7e8'],
                                },
                                {
                                    text: dimension.descriptionAdmin ?? '-',
                                    alignment: 'center',
                                    fillColor: '#f6fbf7',
                                    style: 'text',
                                    fontSize: 14,
                                    margin: [0, 0, 0, 0],
                                    borderColor: ['#e9e7e8', '#e9e7e8', '#e9e7e8', '#e9e7e8'],
                                },
                            ]
                        }),
                        [
                            {
                                text: 'รวม',
                                alignment: 'center',
                                style: 'tableHeader',
                                fontSize: 14,
                                margin: [0, 0, 0, 0],
                                borderColor: ['#e9e7e8', '#e9e7e8', '#e9e7e8', '#e9e7e8'],
                            }, // รวม
                            {
                                text:
                                    isNumberScoreFull && (!isScoreAdminUndefined || !isScoreUserUndefined)
                                        ? totalScoreFull
                                        : '-',
                                alignment: 'center',
                                style: 'tableHeader',
                                fontSize: 14,
                                margin: [0, 0, 0, 0],
                                borderColor: ['#e9e7e8', '#e9e7e8', '#e9e7e8', '#e9e7e8'],
                            }, // รวมคะแนนเต็ม
                            {
                                text: !isScoreUserUndefined && !isScoreUserNull ? totalScoreUser?.toFixed(2) : '-',
                                alignment: 'center',
                                fillColor: '#fffce9',
                                style: 'tableHeader',
                                fontSize: 14,
                                margin: [0, 0, 0, 0],
                                borderColor: ['#e9e7e8', '#e9e7e8', '#e9e7e8', '#e9e7e8'],
                            }, // คะแนนที่ได้ user [ชุมชน]
                            {
                                text:
                                    typeof percentScoreUser === 'number' && !isScoreUserUndefined && !isScoreUserNull
                                        ? `คิดเป็น ${percentScoreUser.toFixed(2)}%`
                                        : '-',
                                alignment: 'center',
                                fillColor: '#fffce9',
                                style: 'tableHeader',
                                fontSize: 14,
                                margin: [0, 0, 0, 0],
                                borderColor: ['#e9e7e8', '#e9e7e8', '#e9e7e8', '#e9e7e8'],
                            }, // ระดับคะแนน admin [ชุมชน]
                            {
                                text: !isScoreAdminUndefined && !isScoreAdminNull ? totalScoreAdmin?.toFixed(2) : '-',
                                alignment: 'center',
                                fillColor: '#f6fbf7',
                                style: 'tableHeader',
                                fontSize: 14,
                                margin: [0, 0, 0, 0],
                                borderColor: ['#e9e7e8', '#e9e7e8', '#e9e7e8', '#e9e7e8'],
                            }, // คะแนนที่ได้   [เจ้าหน้าที่]
                            {
                                text:
                                    typeof percentScoreAdmin === 'number' && !isScoreAdminUndefined && !isScoreAdminNull
                                        ? `คิดเป็น ${percentScoreAdmin.toFixed(2)}%`
                                        : '-',
                                alignment: 'center',
                                fillColor: '#f6fbf7',
                                style: 'tableHeader',
                                fontSize: 14,
                                margin: [0, 0, 0, 0],
                                borderColor: ['#e9e7e8', '#e9e7e8', '#e9e7e8', '#e9e7e8'],
                            }, // ระดับคะแนน
                        ],
                    ],
                },
            }
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [],
    )

    const generateQuestionnaireChart = useCallback(
        ({ name, image, data }: { name: string; image: string; data: DimensionExportToReport[] }) => {
            return [
                {
                    text: `${name}`,
                    bold: true,
                    fontSize: 22,
                },
                {
                    stack: [
                        {
                            image: image,
                            width: 400,
                            height: 400,
                            alignment: 'center',
                            //pageBreak: 'after',
                        },
                    ],
                    margin: [30, 20, 20, 20],
                    alignment: 'center',
                },
                generateTableReport({ data, titleCell: 'ด้านที่', prefixLabel: 'ด้านที่ ' }),
            ]
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [],
    )

    const generateDimensionChart = useCallback(
        ({ data, adminDone, userDone }: { data: DimensionExportToReport[]; adminDone: boolean; userDone: boolean }) => {
            return data.map(({ purposes, ...dimension }, index: number) => {
                let questionOrder = 0
                return [
                    {
                        text: '',
                        pageBreak: 'after',
                    },
                    {
                        text: `ด้านที่ ${dimension.dimensionOrder} ${dimension.name}`,
                        bold: true,
                        fontSize: 22,
                    },
                    {
                        stack: [
                            {
                                image: dimension.dimensionRef,
                                width: 450,
                                // height: 550,
                                alignment: 'center',
                            },
                        ],
                        alignment: 'center',
                        margin: [30, 20, 20, 20],
                    },
                    generateTableReport({
                        data: purposes as SummaryExportToReport[],
                        titleCell: `เป้าประสงค์`,
                        prefixLabel: `เป้าประสงค์ที่ ${index + 1}.`,
                    }),
                    {
                        text: '',
                        pageBreak: 'after',
                    },
                    {
                        text: `ด้านที่ ${dimension.dimensionOrder} ${dimension.name}`,
                        style: 'header',
                        fontSize: 22,
                    },
                    ...purposes.map((purposes, index: number) => {
                        return [
                            {
                                text: `เป้าประสงค์ ${dimension.dimensionOrder}.${purposes.purposeOrder} : ${purposes.name}`,
                                style: 'header',
                                fontSize: 20,
                            },
                            ...purposes.questions.map((question, index: number) => {
                                questionOrder += 1
                                return [
                                    {
                                        text: `${questionOrder}. ${question.name}`,
                                        style: 'header',
                                        fontSize: 16,
                                    },
                                    {
                                        text: `คำอธิบาย : ${
                                            question.questionDescription ? question.questionDescription : ''
                                        }`,
                                        fontSize: 14,
                                    },
                                    {
                                        text: ' ',
                                    },
                                    ...(question.fieldType === 'TEXT'
                                        ? isAdmin
                                            ? adminDone && userDone
                                                ? [
                                                      {
                                                          text: `ชุมชน`,
                                                          fontSize: 14,
                                                      },
                                                      {
                                                          table: {
                                                              widths: ['100%'],
                                                              body: [
                                                                  [
                                                                      {
                                                                          text:
                                                                              question.answersUser !== null
                                                                                  ? question.answersUser
                                                                                  : '',
                                                                          fontSize: 14,
                                                                          margin: [0, 0, 0, 0],
                                                                      },
                                                                  ],
                                                              ],
                                                          },
                                                      },
                                                      {
                                                          text: `เจ้าหน้าที่`,
                                                          fontSize: 14,
                                                      },
                                                      {
                                                          table: {
                                                              widths: ['100%'],
                                                              body: [
                                                                  [
                                                                      {
                                                                          text:
                                                                              question.answersAdmin !== null
                                                                                  ? question.answersAdmin
                                                                                  : '',
                                                                          fontSize: 14,
                                                                          margin: [0, 0, 0, 0],
                                                                      },
                                                                  ],
                                                              ],
                                                          },
                                                      },
                                                  ]
                                                : adminDone && !userDone
                                                ? [
                                                      {
                                                          table: {
                                                              widths: ['100%'],
                                                              body: [
                                                                  [
                                                                      {
                                                                          text:
                                                                              question.answersAdmin !== null
                                                                                  ? question.answersAdmin
                                                                                  : '',
                                                                          fontSize: 14,
                                                                          margin: [0, 0, 0, 0],
                                                                      },
                                                                  ],
                                                              ],
                                                          },
                                                      },
                                                  ]
                                                : [
                                                      {
                                                          table: {
                                                              widths: ['100%'],
                                                              body: [
                                                                  [
                                                                      {
                                                                          text:
                                                                              question.answersUser !== null
                                                                                  ? question.answersUser
                                                                                  : '',
                                                                          fontSize: 14,
                                                                          margin: [0, 0, 0, 0],
                                                                      },
                                                                  ],
                                                              ],
                                                          },
                                                      },
                                                  ]
                                            : [
                                                  {
                                                      table: {
                                                          widths: ['100%'],
                                                          body: [
                                                              [
                                                                  {
                                                                      text:
                                                                          question.answers !== null
                                                                              ? question.answers
                                                                              : '',
                                                                      fontSize: 14,
                                                                      margin: [0, 0, 0, 0],
                                                                  },
                                                              ],
                                                          ],
                                                      },
                                                  },
                                              ]
                                        : [{}]),
                                    // .map Expected to return a value at the end of arrow function
                                    isAdmin &&
                                    adminDone &&
                                    userDone &&
                                    (question.fieldType === 'CHECKBOX' || question.fieldType === 'CHECKBOX_GROUP')
                                        ? {
                                              text: [
                                                  {
                                                      text: 'เจ้าหน้าที่ | ชุมชน',
                                                      fontSize: 14,
                                                  },
                                              ],
                                          }
                                        : '',
                                    ...question.options.map((option) => {
                                        if (question.fieldType === 'CHECKBOX') {
                                            if (isAdmin) {
                                                if (adminDone && userDone) {
                                                    let isCheckedAdmin = question.answersAdmin?.includes(
                                                        option.optionValue,
                                                    )
                                                    let isCheckedUser = question.answersUser?.includes(
                                                        option.optionValue,
                                                    )
                                                    return {
                                                        text: [
                                                            {
                                                                text: isCheckedAdmin ? 'R ' : `£ `,
                                                                font: 'Webdings2',
                                                                fontSize: 14,
                                                            },
                                                            {
                                                                text: `      `,
                                                                fontSize: 14,
                                                            },
                                                            {
                                                                text: isCheckedUser ? 'R ' : `£ `,
                                                                font: 'Webdings2',
                                                                fontSize: 14,
                                                            },
                                                            {
                                                                text: `${option.optionName}`,
                                                                fontSize: 14,
                                                            },
                                                        ],
                                                    }
                                                } else {
                                                    if (adminDone && !userDone) {
                                                        let isChecked = question.answersAdmin?.includes(
                                                            option.optionValue,
                                                        )
                                                        return {
                                                            text: [
                                                                {
                                                                    text: isChecked ? 'R ' : `£ `,
                                                                    font: 'Webdings2',
                                                                    fontSize: 14,
                                                                },
                                                                {
                                                                    text: `${option.optionName}`,
                                                                    fontSize: 14,
                                                                },
                                                            ],
                                                        }
                                                    } else {
                                                        let isChecked = question.answersUser?.includes(
                                                            option.optionValue,
                                                        )
                                                        return {
                                                            text: [
                                                                {
                                                                    text: isChecked ? 'R ' : `£ `,
                                                                    font: 'Webdings2',
                                                                    fontSize: 14,
                                                                },
                                                                {
                                                                    text: `${option.optionName}`,
                                                                    fontSize: 14,
                                                                },
                                                            ],
                                                        }
                                                    }
                                                }
                                            } else {
                                                let isChecked = question.answers?.includes(option.optionValue)
                                                return {
                                                    text: [
                                                        {
                                                            text: isChecked ? 'R ' : `£ `,
                                                            font: 'Webdings2',
                                                            fontSize: 14,
                                                        },
                                                        {
                                                            text: `${option.optionName}`,
                                                            fontSize: 14,
                                                        },
                                                    ],
                                                }
                                            }
                                        } else {
                                            if (isAdmin) {
                                                if (adminDone && userDone) {
                                                    let optionCheckedAdmin =
                                                        question.answersAdmin[0].optionValue === option.optionValue
                                                            ? true
                                                            : false
                                                    let optionCheckedUser =
                                                        question.answersUser[0].optionValue === option.optionValue
                                                            ? true
                                                            : false
                                                    return [
                                                        {
                                                            text: [
                                                                {
                                                                    text: optionCheckedAdmin ? 'R ' : `£ `,
                                                                    font: 'Webdings2',
                                                                    fontSize: 14,
                                                                },
                                                                {
                                                                    text: optionCheckedUser ? ' R' : ` £`,
                                                                    font: 'Webdings2',
                                                                    fontSize: 14,
                                                                },
                                                                {
                                                                    text: `       ${option.optionName}`,
                                                                    fontSize: 14,
                                                                },
                                                            ],
                                                        },
                                                        ...option.subOptions?.map((subOption) => {
                                                            let subOptionCheckedAdmin = question.answersAdmin[0].subOptionValue.includes(
                                                                subOption.subOptionValue,
                                                            )
                                                            let subOptionCheckedUser = question.answersUser[0].subOptionValue.includes(
                                                                subOption.subOptionValue,
                                                            )
                                                            return {
                                                                text: [
                                                                    {
                                                                        text: subOptionCheckedAdmin ? 'R ' : `£ `,
                                                                        font: 'Webdings2',
                                                                        fontSize: 14,
                                                                    },
                                                                    {
                                                                        text: subOptionCheckedUser ? ' R' : ` £`,
                                                                        font: 'Webdings2',
                                                                        fontSize: 14,
                                                                    },
                                                                    {
                                                                        text: `     ${subOption.subOptionName}`,
                                                                        fontSize: 14,
                                                                    },
                                                                ],
                                                                margin: [6, 0, 0, 0],
                                                            }
                                                        }),
                                                    ]
                                                } else if (adminDone && !userDone) {
                                                    let optionChecked =
                                                        question.answersAdmin[0].optionValue === option.optionValue
                                                            ? true
                                                            : false
                                                    return [
                                                        {
                                                            text: [
                                                                {
                                                                    text: optionChecked ? 'R ' : `£ `,
                                                                    font: 'Webdings2',
                                                                    fontSize: 14,
                                                                },
                                                                {
                                                                    text: `  ${option.optionName}`,
                                                                    fontSize: 14,
                                                                },
                                                            ],
                                                        },
                                                        ...option.subOptions?.map((subOption) => {
                                                            let subOptionChecked = question.answersAdmin[0].subOptionValue.includes(
                                                                subOption.subOptionValue,
                                                            )
                                                            return {
                                                                text: [
                                                                    {
                                                                        text: subOptionChecked ? 'R ' : `£ `,
                                                                        font: 'Webdings2',
                                                                        fontSize: 14,
                                                                    },
                                                                    {
                                                                        text: `${subOption.subOptionName}`,
                                                                        fontSize: 14,
                                                                    },
                                                                ],
                                                                margin: [6, 0, 0, 0],
                                                            }
                                                        }),
                                                    ]
                                                } else {
                                                    let optionChecked =
                                                        question.answersUser[0].optionValue === option.optionValue
                                                            ? true
                                                            : false
                                                    return [
                                                        {
                                                            text: [
                                                                {
                                                                    text: optionChecked ? 'R ' : `£ `,
                                                                    font: 'Webdings2',
                                                                    fontSize: 14,
                                                                },
                                                                {
                                                                    text: `  ${option.optionName}`,
                                                                    fontSize: 14,
                                                                },
                                                            ],
                                                        },
                                                        ...option.subOptions?.map((subOption) => {
                                                            let subOptionChecked = question.answersUser[0].subOptionValue.includes(
                                                                subOption.subOptionValue,
                                                            )
                                                            return {
                                                                text: [
                                                                    {
                                                                        text: subOptionChecked ? 'R ' : `£ `,
                                                                        font: 'Webdings2',
                                                                        fontSize: 14,
                                                                    },
                                                                    {
                                                                        text: `${subOption.subOptionName}`,
                                                                        fontSize: 14,
                                                                    },
                                                                ],
                                                                margin: [6, 0, 0, 0],
                                                            }
                                                        }),
                                                    ]
                                                }
                                            } else {
                                                let optionChecked =
                                                    question.answers[0].optionValue === option.optionValue
                                                        ? true
                                                        : false
                                                return [
                                                    {
                                                        text: [
                                                            {
                                                                text: optionChecked ? 'R ' : `£ `,
                                                                font: 'Webdings2',
                                                                fontSize: 14,
                                                            },
                                                            {
                                                                text: `  ${option.optionName}`,
                                                                fontSize: 14,
                                                            },
                                                        ],
                                                    },
                                                    ...option.subOptions?.map((subOption) => {
                                                        let subOptionChecked = question.answers[0].subOptionValue.includes(
                                                            subOption.subOptionValue,
                                                        )
                                                        return {
                                                            text: [
                                                                {
                                                                    text: subOptionChecked ? 'R ' : `£ `,
                                                                    font: 'Webdings2',
                                                                    fontSize: 14,
                                                                },
                                                                {
                                                                    text: `${subOption.subOptionName}`,
                                                                    fontSize: 14,
                                                                },
                                                            ],
                                                            margin: [6, 0, 0, 0],
                                                        }
                                                    }),
                                                ]
                                            }
                                        }
                                    }),
                                    {
                                        text: ' ',
                                    },
                                    ...generateFilesAndLinks(question),
                                    {
                                        text: ' ',
                                    },

                                    ...generateSuggestion(question, adminDone, userDone, dimension.scoreAdmin),

                                    {
                                        text: ' ',
                                    },
                                    {
                                        stack: [
                                            {
                                                image: lineGrey,
                                                width: 550,
                                                height: 1,
                                            },
                                        ],
                                    },
                                    {
                                        text: ' ',
                                    },
                                ]
                            }),
                        ]
                    }),
                ]
            })
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [],
    )

    const generateFilesAndLinks = useCallback((question: QuestionsExportToReport) => {
        let fileDataSource = Array.from({
            length: Math.max(question.link.length, question.file.length),
        })
            .fill(1)
            .map((item, index) => ({
                file: {
                    fileName: question.file[index]?.fileName ? question.file[index]?.fileName : '',
                    path: `${process.env.REACT_APP_API_UPLOAD_PATH_URL}${question.file[index]?.path}`,
                },
                link: question.link[index]?.link ? question.link[index]?.link : '',
            }))
        if (fileDataSource.length === 0) {
            fileDataSource = [{ file: { fileName: `ไม่มีข้อมูล`, path: '' }, link: `ไม่มีข้อมูล` }]
        } else {
            if (!fileDataSource[0]?.file) {
                fileDataSource[0].file = { fileName: `ไม่มีข้อมูล`, path: '' } //style in line 242
            }
            if (!fileDataSource[0]?.link) {
                fileDataSource[0].link = 'ไม่มีข้อมูล'
            }
        }

        return [
            {
                text: 'เอกสารแนบ',
                fontSize: 14,
                bold: true,
            },
            {
                table: {
                    widths: ['50%', '50%'],
                    body: [
                        [
                            {
                                text: 'รายการเอกสาร',
                                fontSize: 14,
                                fillColor: '#EEF8F2',
                                borderColor: ['#e9e7e8', '#e9e7e8', '#e9e7e8', '#e9e7e8'],
                            },
                            {
                                text: 'ลิงก์เอกสารจากพื้นที่จัดเก็บอื่น',
                                fontSize: 14,
                                fillColor: '#EEF8F2',
                                borderColor: ['#e9e7e8', '#e9e7e8', '#e9e7e8', '#e9e7e8'],
                            },
                        ],
                        ...fileDataSource.map((data) => {
                            return [
                                data.file.fileName === 'ไม่มีข้อมูล'
                                    ? {
                                          text: 'ไม่มีข้อมูล',
                                          fontSize: 14,
                                          borderColor: ['#e9e7e8', '#e9e7e8', '#e9e7e8', '#e9e7e8'],
                                      }
                                    : {
                                          text: data.file.fileName,
                                          fontSize: 14,
                                          link: data.file.path,
                                          decoration: 'underline',
                                          borderColor: ['#e9e7e8', '#e9e7e8', '#e9e7e8', '#e9e7e8'],
                                      },
                                data.link === 'ไม่มีข้อมูล'
                                    ? {
                                          text: 'ไม่มีข้อมูล',
                                          fontSize: 14,
                                          borderColor: ['#e9e7e8', '#e9e7e8', '#e9e7e8', '#e9e7e8'],
                                      }
                                    : {
                                          text: `${decodeURIComponent((data.link + '').replace(/\+/g, '%20'))}`,
                                          fontSize: 14,
                                          link: data.link,
                                          decoration: 'underline',
                                          borderColor: ['#e9e7e8', '#e9e7e8', '#e9e7e8', '#e9e7e8'],
                                      },
                            ]
                        }),
                    ],
                },
            },
        ]

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const generateSuggestion = useCallback(
        (
            question: QuestionsExportToReport,
            adminDone: boolean,
            userDone: boolean,
            scoreAdmin: number | null | undefined,
        ) => {
            return [
                ...(!isAdmin || (isAdmin && userDone)
                    ? [
                          {
                              text: `หมายเหตุและข้อคิดเห็นจากชุมชน`,
                              bold: true,
                              fontSize: 14,
                          },
                          {
                              text: `${question.suggestionUser ? question.suggestionUser : 'ไม่มีข้อมูล'}`,
                              fontSize: 14,
                          },
                      ]
                    : [{}]),
                ...(scoreAdmin && (!isAdmin || (isAdmin && adminDone))
                    ? [
                          {
                              text: `หมายเหตุและข้อคิดเห็นจากเจ้าหน้าที่`,
                              bold: true,
                              fontSize: 14,
                          },
                          {
                              text: `${question.suggestionAdmin ? question.suggestionAdmin : 'ไม่มีข้อมูล'}`,
                              fontSize: 14,
                          },
                      ]
                    : [{}]),
            ]
            // eslint-disable-next-line react-hooks/exhaustive-deps
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [],
    )

    const downloadFullReportPdf = useCallback(async (props: { data: OverviewFullPreviewReportStructureExport[] }) => {
        //setLoadingDownloadFullReportPdf(true)
        const { data = [] } = props
        const docDefinition = getDocDefinitionPdf({ data })
        pdfMake.createPdf(await docDefinition).download('รายงานสรุปภาพรวมของแบบประเมิน', () => {
            loadingStore.setLoading(false)
        })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const openFullReportPdf = useCallback(async (props: { data: OverviewFullPreviewReportStructureExport[] }) => {
        setLoadingOpenFullReportPdf(true)
        const { data = [] } = props

        const docDefinition = getDocDefinitionPdf({ data })
        pdfMake.createPdf(await docDefinition).open({
            progressCallback: (progress: number) => {
                if (progress === 1) {
                    setLoadingOpenFullReportPdf(false)
                }
            },
        })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const openFullReportPdfSamePage = useCallback(
        async (props: { data: OverviewFullPreviewReportStructureExport[] }) => {
            setLoadingOpenFullReportPdf(true)
            const { data = [] } = props

            const docDefinition = getDocDefinitionPdf({ data })
            pdfMake.createPdf(await docDefinition).open(
                {
                    progressCallback: (progress: number) => {
                        if (progress === 1) {
                            setLoadingOpenFullReportPdf(false)
                        }
                    },
                },
                window,
            )
            // eslint-disable-next-line react-hooks/exhaustive-deps
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [],
    )

    return {
        downloadFullReportPdf,
        openFullReportPdf,
        isLoadingDownloadFullReportPdf,
        isLoadingOpenFullReportPdf,
        openFullReportPdfSamePage,
    }
}

export default useExportFullReportOverviewPDF
